import React from "react";

const About = () => {
  return (
    <section className="section about-section">
      <h1 className="section-title">about us</h1>
      <p>
        Lorem ipsum dolor sit amet consectetur, adipisicing elit. Voluptates
        maiores, possimus atque ipsum voluptate, dolorum perferendis nam est
        velit sapiente perspiciatis mollitia temporibus delectus magnam minima
        eaque? Vitae rem praesentium et quae illo assumenda, veniam autem
        commodi rerum voluptate doloremque.
      </p>
    </section>
  );
};

export default About;
